import { createComponent } from '@/helpers/alpine';

const Range = createComponent(
    (opts: {
        from: string;
        to: string;
        min: number;
        max: number;
        withUrl: boolean;
        unit: string;
    }) => ({
        from: opts.from,
        to: opts.to,
        min: opts.min,
        max: opts.max,
        minThumb: 0 as number,
        maxThumb: 0 as number,
        withUrl: opts.withUrl,
        unit: opts.unit,

        minTrigger() {
            this.from = String(
                Math.min(Number(this.from), Number(this.to) - 1),
            );
            this.minThumb =
                ((Number(this.from) - this.min) / (this.max - this.min)) * 100;

            const input = this.$refs.input as HTMLInputElement;
            const values = input.value.split('-');

            input.value = this.from + '-' + values[1];
        },

        maxTrigger() {
            this.to = String(Math.max(Number(this.to), Number(this.from) + 1));
            this.maxThumb =
                100 -
                ((Number(this.to) - this.min) / (this.max - this.min)) * 100;

            const input = this.$refs.input as HTMLInputElement;
            const values = input.value.split('-');

            input.value = values[0] + '-' + this.to;
        },

        init() {
            this.minTrigger();
            this.maxTrigger();

            const { from, to } = this.$refs as {
                from: HTMLInputElement;
                to: HTMLInputElement;
            };

            from.addEventListener('input', (event) => {
                this.from = (event.target as HTMLInputElement).value;

                if (Number(this.from) > Number(to.value)) {
                    this.to = this.from;
                    this.from = to.value;
                }
            });
            from.addEventListener('change', () =>
                this.$el.dispatchEvent(new Event('change')),
            );

            to.addEventListener('input', (event) => {
                this.to = (event.target as HTMLInputElement).value;

                if (Number(this.to) < Number(from.value)) {
                    this.from = this.to;
                    this.to = from.value;
                }
            });
            to.addEventListener('change', () =>
                this.$el.dispatchEvent(new Event('change')),
            );

            if (this.withUrl) {
                const url = new URL(this.$el.dataset.searchUrl as string);
                const query = (url.searchParams.get('q') ?? '').split('/');

                const updateUrl = () => {
                    const rangeQuery = `price-${this.unit}-${this.from}-${this.to}`;

                    const nextQuery = query?.filter((q) => !q.match(/^price-/));
                    nextQuery?.push(rangeQuery);

                    url.searchParams.set('q', nextQuery.join('/'));
                    this.$el.dataset.searchUrl = url.toString();
                };
                this.$watch('from', updateUrl);
                this.$watch('to', updateUrl);
            }
        },
    }),
);

export { Range };
